import { DT } from './dateTime';

if (new Date().getFullYear() === 2028) {
    console.warn('*******************************************');
    console.warn('***** holidaySet needs to be updated! *****');
    console.warn('*******************************************');
}

/** Ref: https://www.opm.gov/policy-data-oversight/pay-leave/federal-holidays/ */
export const holidaySet = new Set<string>([
    // 2022
    '2022-01-17', // Mon, Jan 17   Birthday of Martin Luther King, Jr.
    '2022-02-21', // Mon, Feb 21   Washington’s Birthday
    '2022-05-30', // Mon, May 30   Memorial Day
    '2022-06-20', // Mon, Jun 20 * Juneteenth National Independence Day
    '2022-07-04', // Mon, Jul 04   Independence Day
    '2022-09-05', // Mon, Sep 05   Labor Day
    '2022-10-10', // Mon, Oct 10   Columbus Day
    '2022-11-11', // Fri, Nov 11   Veterans Day
    '2022-11-24', // Thu, Nov 24   Thanksgiving Day
    '2022-12-26', // Mon, Dec 26 * Christmas Day
    // 2023
    '2023-01-02', // Mon, Jan 02 * New Year’s Day
    '2023-01-16', // Mon, Jan 16   Birthday of Martin Luther King, Jr.
    '2023-02-20', // Mon, Feb 20   Washington’s Birthday
    '2023-05-29', // Mon, May 29   Memorial Day
    '2023-06-19', // Mon, Jun 19   Juneteenth National Independence Day
    '2023-07-04', // Tue, Jul 04   Independence Day
    '2023-09-04', // Mon, Sep 04   Labor Day
    '2023-10-09', // Mon, Oct 09   Columbus Day
    '2023-11-10', // Fri, Nov 10 * Veterans Day
    '2023-11-23', // Thu, Nov 23   Thanksgiving Day
    '2023-12-25', // Mon, Dec 25   Christmas Day
    // 2024
    '2024-01-01', // Mon, Jan 01   New Year’s Day
    '2024-01-15', // Mon, Jan 15   Birthday of Martin Luther King, Jr.
    '2024-02-19', // Mon, Feb 19   Washington’s Birthday
    '2024-05-27', // Mon, May 27   Memorial Day
    '2024-06-19', // Wed, Jun 19   Juneteenth National Independence Day
    '2024-07-04', // Thu, Jul 04   Independence Day
    '2024-09-02', // Mon, Sep 02   Labor Day
    '2024-10-14', // Mon, Oct 14   Columbus Day
    '2024-11-11', // Mon, Nov 11   Veterans Day
    '2024-11-28', // Thu, Nov 28   Thanksgiving Day
    '2024-12-25', // Wed, Dec 25   Christmas Day
    // 2025
    '2025-01-01', // Wed, Jan 01   New Year’s Day
    '2025-01-20', // Mon, Jan 20   Birthday of Martin Luther King, Jr. / Inauguration Day
    '2025-02-17', // Mon, Feb 17   Washington’s Birthday
    '2025-05-26', // Mon, May 26   Memorial Day
    '2025-06-19', // Thu, Jun 19   Juneteenth National Independence Day
    '2025-07-04', // Fri, Jul 04   Independence Day
    '2025-09-01', // Mon, Sep 01   Labor Day
    '2025-10-13', // Mon, Oct 13   Columbus Day
    '2025-11-11', // Tue, Nov 11   Veterans Day
    '2025-11-27', // Thu, Nov 27   Thanksgiving Day
    '2025-12-25', // Thu, Dec 25   Christmas Day
    // 2026
    '2026-01-01', // Thu, Jan 01   New Year’s Day
    '2026-01-19', // Mon, Jan 19   Birthday of Martin Luther King, Jr.
    '2026-02-16', // Mon, Feb 16   Washington’s Birthday
    '2026-05-25', // Mon, May 25   Memorial Day
    '2026-06-19', // Fri, Jun 19   Juneteenth National Independence Day
    '2026-07-03', // Fri, Jul 03 * Independence Day
    '2026-09-07', // Mon, Sep 07   Labor Day
    '2026-10-12', // Mon, Oct 12   Columbus Day
    '2026-11-11', // Wed, Nov 11   Veterans Day
    '2026-11-26', // Thu, Nov 26   Thanksgiving Day
    '2026-12-25', // Fri, Dec 25   Christmas Day
    // 2027
    '2027-01-01', // Fri, Jan 01   New Year’s Day
    '2027-01-18', // Mon, Jan 18   Birthday of Martin Luther King, Jr.
    '2027-02-15', // Mon, Feb 15   Washington’s Birthday
    '2027-05-31', // Mon, May 31   Memorial Day
    '2027-06-18', // Fri, Jun 18 * Juneteenth National Independence Day
    '2027-07-05', // Mon, Jul 05 * Independence Day
    '2027-09-06', // Mon, Sep 06   Labor Day
    '2027-10-11', // Mon, Oct 11   Columbus Day
    '2027-11-11', // Thu, Nov 11   Veterans Day
    '2027-11-25', // Thu, Nov 25   Thanksgiving Day
    '2027-12-24', // Fri, Dec 24 * Christmas Day
    // 2028
    '2027-12-31', // Sun, Jan 01 * New Year’s Day
    '2028-01-17', // Mon, Jan 17   Birthday of Martin Luther King, Jr.
    '2028-02-21', // Mon, Feb 21   Washington’s Birthday
    '2028-05-29', // Mon, May 29   Memorial Day
    '2028-06-19', // Mon, Jun 19   Juneteenth National Independence Day
    '2028-07-04', // Tue, Jul 04   Independence Day
    '2028-09-04', // Mon, Sep 04   Labor Day
    '2028-10-09', // Mon, Oct 09   Columbus Day
    '2028-11-10', // Fri, Nov 10 * Veterans Day
    '2028-11-23', // Thu, Nov 23   Thanksgiving Day
    '2028-12-25', // Mon, Dec 25   Christmas Day
]);

// * If a holiday falls on a Saturday, for most Federal employees, the preceding Friday will be treated as a holiday for pay
//   and leave purposes. (See 5 U.S.C. 6103(b).) If a holiday falls on a Sunday, for most Federal employees, the following Monday
//   will be treated as a holiday for pay and leave purposes. (See Section 3(a) of Executive Order 11582, February 11, 1971.)
//   See also our Federal Holidays – "In Lieu Of" Determination Fact Sheet at
//   https://www.opm.gov/policy-data-oversight/pay-leave/work-schedules/fact-sheets/Federal-Holidays-In-Lieu-Of-Determination.

export const isHoliday = (d: DT): boolean => {
    return holidaySet.has(d.toDateStr());
};
